import React, { useEffect } from 'react';
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Table, TableBody, TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    boxShadow: theme.shadows[20],
    maxHeight: '100%',
    overflowY: 'auto',
    maxWidth: '100%'
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  actions: {
    justifyContent: 'flex-end'
  },
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {},
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  form: {
    height: '100%',
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  tabActive: {
    color: '#1E69E5',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  },
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
  tableMarginTop: {
    marginTop: 24,
  },
}));

const AddAccoladeDialog = ({
  open,
  onClose,
  excludedAccolades,
  fetchExcludedAccolades,
  handleAddAccoladeToTeam,
}) => {
  const classes = useStyles();

  useEffect(() => {
    if (open) {
      fetchExcludedAccolades();
    }
  }, [open, fetchExcludedAccolades]);

  const headCells = [
    { id: 'id', label: 'Id' },
    { id: 'logo', label: 'Logo' },
    { id: 'outlet', label: 'Outlet' },
    { id: 'description', label: 'Accolade' },
    { id: 'year', label: 'Year' },
    { id: 'team_ids', label: 'Associated Groups' },
  ];

  const renderRow = (props) => (
    <TableRow key={props.id}>
      <TableCell>{props.id}</TableCell>
      <TableCell>
        <Avatar src={props.logo}
          alt={props.outlet}>{props.outlet?.[0]}
        </Avatar>
      </TableCell>
      <TableCell>{props.outlet}</TableCell>
      <TableCell>{props.description}</TableCell>
      <TableCell>{props.year}</TableCell>
      <TableCell>{props.team_ids ? props.team_ids.length : 0}</TableCell>
      <TableCell>
        <Link to='' onClick={() => handleAddAccoladeToTeam(props.id)}>Add</Link>
      </TableCell>
    </TableRow>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Add Accolade</DialogTitle>
      <DialogContent dividers>
        {excludedAccolades ? <Table className={classes.tableMarginTop}>
          <TableHead>
            <TableRow>
              {headCells.map((headCell) => (
                <TableCell key={headCell.id}>
                  {headCell.label}
                </TableCell>
              ))}
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {excludedAccolades == undefined ?
              <TableRow><TableCell>Loading...</TableCell></TableRow> : excludedAccolades.map(renderRow.bind(this))}
          </TableBody>
        </Table> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddAccoladeDialog;
